import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RouterModule } from '@angular/router';
import { CalculatorModule } from '@studiobuki/web-core/lib/calculator';
import { AsideComponent } from './aside.component';
import { HeaderComponent } from './components/header/header.component';
import { ProductModule } from './components/product/product.module';
import { LinkComponent } from './components/link/link.component';
import { ToggleComponent } from './components/toggle/toggle.component';

@NgModule({
  declarations: [
    AsideComponent,
    HeaderComponent,
    LinkComponent,
    ToggleComponent,
  ],
  imports: [
    CommonModule,
    CalculatorModule,
    ProductModule,
    AngularSvgIconModule,
    RouterModule,
  ],
  exports: [AsideComponent],
})
export class AsideModule {}
